import React from 'react';
import { motion } from 'framer-motion';
import { ShirtIcon, QrCodeIcon, LinkIcon, UserXIcon } from 'lucide-react';
const problems = [{
  icon: <ShirtIcon className="w-5 h-5 text-red-400" data-id="element-382" />,
  title: 'Static & Forgettable',
  description: 'Regular merch does nothing. No interaction, no connection.'
}, {
  icon: <QrCodeIcon className="w-5 h-5 text-red-400" data-id="element-383" />,
  title: 'QR Codes Are Clunky',
  description: 'Scanning printed codes ruins the design and feels outdated.'
}, {
  icon: <LinkIcon className="w-5 h-5 text-red-400" data-id="element-384" />,
  title: 'Links Get Lost',
  description: 'Business cards get tossed. Social handles get forgotten.'
}, {
  icon: <UserXIcon className="w-5 h-5 text-red-400" data-id="element-385" />,
  title: 'No Personal Touch',
  description: 'Generic clothing says nothing about who you actually are.'
}];
export function ProblemSection() {
  return <section className="py-10 md:py-20 bg-brand-dark relative" data-id="element-386">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-387">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-388">
          <span className="text-brand-cyan font-bold tracking-widest uppercase text-xs sm:text-sm mb-3 block" data-id="element-389">
            The Problem
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-bold mb-3 md:mb-6" data-id="element-390">
            Your Clothing Is Stuck in the Past
          </h2>
          <p className="text-gray-400 text-sm md:text-lg" data-id="element-391">
            We live in a hyper-connected digital world, yet the things we wear
            every day haven't evolved in decades.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6" data-id="element-392">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="glass-card p-4 md:p-8 border-red-500/10 hover:border-red-500/30 transition-colors group" data-id="element-393">
              <div className="w-10 h-10 md:w-14 md:h-14 rounded-xl md:rounded-2xl bg-red-500/10 flex items-center justify-center mb-3 md:mb-6 group-hover:scale-110 transition-transform" data-id="element-394">
                {problem.icon}
              </div>
              <h3 className="text-sm sm:text-base md:text-xl font-bold mb-1.5 md:mb-3" data-id="element-395">
                {problem.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-xs md:text-sm" data-id="element-396">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}